import { useEffect, useState } from "react";
import Loader from "../../../../../components/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import ReconciliationTable from "../../../../../components/ReconcilationTable/ReconciliationTable";
import ShipperDetailsTable from "../../../../../components/ShipperDetailTable/ShipperDetailTable";
import {
  fetchOnLoadReconcilliationSiteDataService,
  submitReconcilliationDatService,
} from "../../../../../services/siteManagamentService";
import { notifySuccess, notifyWarning } from "../../../../../utilities/helper";
import ReconcileConfirmationPage from "./ReconcileConfirmationPage/ReconcileConfirmationPage";

const ReconcileDrugSite = () => {
  const id = useLocation()?.state?.id;
  const patientId = useLocation()?.state?.patientId;
  // const siteName = useLocation()?.state?.name;
  const access_token = localStorage.getItem("access_token");
  const currentUserCultureCode = localStorage?.getItem(
    "currentUserCultureCode",
  );
  const roleId = localStorage.getItem("roleId");

  const [updatedData, setUpdatedData] = useState([]);
  const [reconciliationData, setReconciliationData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [load, setLoad] = useState(false);
  const [showConfirmationPage, setShowConfirmationPage] = useState(false);
  const [confirmationData, setConfirmationData] = useState(null);
  const [siteName, setSiteName] = useState("");
  const [siteId, setSiteId] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (id && currentUserCultureCode) {
      getDataOnLoad(id);
    } else if (patientId && currentUserCultureCode) {
      getDataOnLoad(null, patientId);
    }
  }, [id, patientId]);

  const handleReconciliationData = (data) => {
    let nonNullData = Object.keys(data)?.filter((key) => data[key] !== null);

    const tempData = reconciliationData
      .filter((item) => nonNullData?.includes(String(item.drugId)))
      .map((item) => ({
        id: item.drugId,
        drugKitNumber: item.drugKitNumber,
        status: data[item.drugId],
      }));

    setUpdatedData(tempData);
  };

  const getDataOnLoad = async (siteId = null, patientId = null) => {
    try {
      setLoad(true);
      const res = await fetchOnLoadReconcilliationSiteDataService(
        access_token,
        siteId,
        currentUserCultureCode,
        patientId,
      );
      if (
        res?.status == 200 &&
        res?.data?.message === "Onload data extracted!"
      ) {
        const data =
          res?.data?.result?.drugReturnConfiguration?.patientVisitDrugs?.map(
            (item) => ({
              drugId: item?.id,
              drugId_new: item?.drugId,
              statusText: item?.drug?.statusText,
              packingType: item?.drug?.packageName,
              patientVisitId: item?.patientVisitId,
              drugStatusTypeId: item?.drugStatusTypeId,
              drugKitNumber: item?.drug?.drugKitNumber,
            }),
          );
        setReconciliationData(data);
        setSiteName(res?.data?.result?.siteName);
        setSiteId(res?.data?.result?.siteId);
        setStatusData(
          res?.data?.result?.drugReturnConfiguration?.drugStatusTypes,
        );
      }
    } catch (err) {
      console.log(err?.message);
      if (err?.status == 401) {
        navigate("/unAuthorized");
      }
    } finally {
      setLoad(false);
    }
  };

  const submitData = async () => {
    try {
      setLoad(true);

      const reconciledDrugList = reconciliationData
        ?.filter((rec) => updatedData.some((upd) => upd.id === rec.drugId))
        ?.map((rec) => {
          const matched = updatedData.find((upd) => upd.id === rec.drugId);
          return {
            id: rec?.drugId,
            drugId: rec?.drugId_new,
            patientVisitId: rec?.patientVisitId,
            drugKitNumber: rec?.drugKitNumber,
            drugStatusTypeId: rec?.drugStatusTypeId,
            changedDrugStatusTypeId: matched?.status,
            isChangedDrugStatusType: true,
          };
        });

      const payload = {
        siteId: id,
        reconciledDrugList: reconciledDrugList,
      };

      const res = await submitReconcilliationDatService(
        access_token,
        payload,
        roleId,
      );
      if (
        res?.status == 200 &&
        res?.data?.message === "Reconciliation successfull!"
      ) {
        notifySuccess(res?.data?.message);
        setShowConfirmationPage(true);
        setConfirmationData(res?.data?.result?.slice(0, -2));
      } else if (
        res?.status === 200 &&
        res?.data?.message === "At least one drug must be reconciled!"
      ) {
        notifyWarning(res?.data?.message);
      }
    } catch (err) {
      console.log("Error : ", err?.message);
      if (err?.status === 401) {
        navigate("/unAuthorized");
      }
    } finally {
      setLoad(false);
    }
  };

  return (
    <>
      {showConfirmationPage ? (
        <ReconcileConfirmationPage
          data={confirmationData}
          setShowConfirm={setShowConfirmationPage}
          siteId={id ? id : siteId}
          siteName={siteName || "Site Details"}
        />
      ) : (
        <>
          {load ? (
            <Loader />
          ) : (
            <div className="content-body">
              <p className="bread-crumbs-link-container">
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) => navigate("/")}
                >
                  Home
                </button>{" "}
                |{" "}
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) => navigate("/site-management")}
                >
                  Site Management
                </button>{" "}
                |{" "}
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) =>
                    navigate("/addUpdate-site-management", {
                      state: { id: id ? id : siteId },
                    })
                  }
                >
                  {siteName || "Site Details"}
                </button>
                |
                <button className="bread-crumbs-btn">
                  CRA Site Reconciliation
                </button>
                -{" "}
                <b style={{ color: "gray" }}>
                  {localStorage?.getItem("studyName")}
                </b>
              </p>

              <Grid2
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", margin: "0 auto" }}
              >
                <Grid2 item md={4}>
                  <p className="page-heading">CRA Site Reconciliation</p>
                </Grid2>
              </Grid2>

              <div>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    margin: "2px auto",
                    textAlign: "start",
                  }}
                >
                  Kit Status Updates{" "}
                  <span
                    style={{
                      color: "gray",
                    }}
                  >
                    {siteName || "Site Details"}
                  </span>
                </div>
              </div>
              {/* 
          <div
            style={{
              maxHeight: "1200px",
              overflowY: "auto",
              width: "100%",
            }}
          >
            <ReconciliationTable
              data={reconciliationData}
              onChange={handleReconcileDrugData}
            />
          </div> */}
              {reconciliationData && reconciliationData?.length > 0 ? (
                <div
                  style={
                    {
                      // maxHeight: "500px",
                      // overflowY: "auto",
                      // width: "100%",
                      // marginTop: "20px",
                    }
                  }
                >
                  <ShipperDetailsTable
                    actions={statusData}
                    data={reconciliationData}
                    isReset={false}
                    onChange={handleReconciliationData}
                    isCustomColumn={true}
                  />
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    border: "1px solid lightgrey",
                    marginTop: "20px",
                    borderRadius: "5px",
                  }}
                >
                  <h3
                    style={{
                      color: "gray",
                    }}
                  >
                    No Data Available
                  </h3>
                </div>
              )}

              <Grid2
                alignItems={"end"}
                justifyContent="end"
                container
                gap={3}
                sx={{ marginTop: "2%" }}
              >
                <Grid2 item md={6}>
                  <button
                    onClick={submitData}
                    disabled={reconciliationData?.length === 0}
                    className={
                      reconciliationData?.length === 0
                        ? "disabled-btn"
                        : "create-btn"
                    }
                  >
                    Save
                  </button>
                </Grid2>
              </Grid2>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ReconcileDrugSite;
